import { Inventory } from 'components/Protected/Inventory'

export function InventoryPage() {
  return <Inventory />
}

